const DOCUMENT = 'ADMIN_EDIT_UNMATCHED_OPTION';

const actions = {
  LOAD: DOCUMENT + 'LOAD',
  LOAD_SUCCESS: DOCUMENT + 'LOAD_SUCCESS',
  CLEAR_STORE: DOCUMENT + 'CLEAR_STORE',
  DELETE: DOCUMENT + 'DELETE',
  ADD: DOCUMENT + 'ADD',
  CREATE: DOCUMENT + 'CREATE',
  CHANGE_PROPERTY: DOCUMENT + 'CHANGE_PROPERTY',
  TOUCH: DOCUMENT + 'TOUCH',
  SAVE: DOCUMENT + 'SAVE',
  SAVE_ERROR: DOCUMENT + 'SAVE_ERROR',

  loadData: data => ({
    type: actions.LOAD,
    payload: data,
  }),

  loadDataSuccess: data => ({
    type: actions.LOAD_SUCCESS,
    payload: data,
  }),

  clearStore: () => ({
    type: actions.CLEAR_STORE,
  }),

  delete: data => ({
    type: actions.DELETE,
    payload: data,
  }),

  add: data => ({
    type: actions.ADD,
    payload: data,
  }),

  create: () => ({
    type: actions.CREATE,
  }),

  save: data => ({
    type: actions.SAVE,
    payload: data,
  }),

  saveError: data => ({
    type: actions.SAVE_ERROR,
    payload: data,
  }),

  changeProperty: data => ({
    type: actions.CHANGE_PROPERTY,
    payload: data,
  }),

  touch: data => ({
    type: actions.TOUCH,
    payload: data,
  }),
};

export default actions;
